var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "search" } }, [
    _c("div", { staticClass: "search_main" }, [
      _c("div", { staticClass: "search_icon", on: { click: _vm.tosearch } }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.key,
            expression: "key",
          },
        ],
        class: { active: _vm.input_active },
        attrs: { type: "text", placeholder: "搜索物品" },
        domProps: { value: _vm.key },
        on: {
          focus: _vm.focus,
          blur: _vm.blur,
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.tosearch.apply(null, arguments)
          },
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.key = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }